import { DEFAULT_TEXT_COLOR, DEFAULT_FONTFAMILY } from 'theme/theme';
export default {
  NotAccurate: {
    // root
    font: `400 15px/24px ${DEFAULT_FONTFAMILY}`,
    color: DEFAULT_TEXT_COLOR,
    padding: [10, 0 , 20],
  },
};
